<template>
  <div style="background-color:#ffffff">
    <div class="title-main">
      <h1>{{ $t("messages.aboutUs") }}</h1>
    </div>
    <div class="subcontainer">
      <div class="p-grid">
        <div class="p-md-6 minicontainer">
          <h2>{{ $t("messages.whoWeAre") }}</h2>
          <p>
            {{ $t("messages.whoWeAreDescription") }}
          </p>
        </div>

        <div class="p-md-6 minicontainer">
          <h2>{{ $t("messages.whatWeOffer") }}</h2>
          <p>
            {{ $t("messages.whatWeOfferDescription") }}
          </p>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-md-6 minicontainer image-container">
          <img src="@/assets/layout/images/quienes_qualyticare.png" alt="" class="image-cirugia" />
        </div>
        <div class="p-md-6 minicontainer image-container">
          <img src="@/assets/layout/images/que_ofrecemos_qualitycare.png" alt="" class="image-cirugia" />
        </div>
      </div>
      <div class="p-grid p-pb-6">
        <div class="p-col-12">
          <h2>{{ $t("messages.ourValues") }}</h2>
        </div>
        <div class="p-col-12 container-iconos-valores">
          <div class="container-icon-label" v-for="item in [...columna1,...columna2]" :key="item.icono">
            <img :src="`../assets/layout/icons/${item.icono}`" :alt="item[idioma].label" />
            <span>{{ item[idioma].label }}</span>
          </div>
        </div>
        <div class="p-md-6 p-px-6">
          <p class="p-mb-5" v-for="item in columna1" :key="JSON.stringify(item)">
            <strong>{{ item[idioma].label }}:</strong> {{ item[idioma].message }}
          </p>
        </div>
        <div class="p-md-6 p-px-6">
          <p class="p-mb-5" v-for="item in columna2" :key="JSON.stringify(item)">
            <strong>{{ item[idioma].label }}:</strong> {{ item[idioma].message }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  metaInfo: {
    title: 'Quienes somos - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Quienes somos',
        content: 'Descripción de quienes somos en QualityCare',
      },
    ],
  },
  name: "NosotrosMain",
  data() {
    return {
        columna1: [
          {
            icono: "respeto.png",
            es:{
              label: "Respeto",
              message: "Aceptar que todos somos diferentes. ",
            },            
            en:{
              label:"Respect",
              message: "Accept that we are all different. ",
            },
            fr:{            
              label: "Respect",            
              message: "Accepter que nous sommes tous différents."
            }
          },
          {
            icono: "excelencia.png",
            es:{
              label: "Calidad",
              message: "Capacidad de organización para satisfacer la necesidades y expectativas de nuestros pacientes. ",
            },            
            en:{
              label:"Quality",
              message: "Organizational skills to meet the needs and expectations of our patients. ",
            },
            fr:{            
              label: "Qualité",                        
              message: "Avoir des compétences organisationnelles pour répondre aux besoins et aux attentes de nos patients."
            }
          },
          {
            icono: "honestidad.png",
            es:{
              label: "Honestidad",
              message: "Tener integridad y conciencia de si mismo. ",
            },            
            en:{
              label:"Honesty",
              message: "Having integrity and self-awareness. ",
            },
            fr:{            
              label: "Honnêteté",            
              message: "Faire preuve d'intégrité et de conscience de soi."
            }
          },
          {
            icono: "profesionalismo.png",
            es:{
              label: "Profesionalismo",
              message: "Actuando con responsabilidad, integridad, confiabilidad y excelencia.",
            },            
            en:{
              label:"Professionalism",
              message: "Acting with responsibility, integrity, reliability and excellence.",
            },
            fr:{            
              label: "Professionnalisme",            
              message: "Agir avec responsabilité, intégrité, fiabilité et excellence"
            }
          },
          {
            icono: "compromiso.png",
            es:{
              label: "Responsabilidad",
              message: "Contribuyendo al desarrollo sostenible. ",
            },            
            en:{
              label:"Responsibility",
              message: "Contributing to sustainable development. ",
            },
            fr:{            
              label: "Responsabilité",            
              message: "Contribuer au développement durable."
            }
          }
        ],
        columna2: [
          {
            icono: "transparencia.png",
            es:{
              label: "Transparencia",
              message: "Construir relaciones de confianza con las entidades y pacientes.",
            },            
            en:{
              label:"Transparency",
              message: "Building relationships of trust with entities and patients.",
            },
            fr:{            
              label: "Transparence",            
              message: "Établir des relations de confiance avec les entités et les patients"
            }
          },
          {
            icono: "diligencia.png",
            es:{
              label: "Diligencia",
              message: "Actuar con disposición, hacer las cosas bien y cumplir con los compromisos. ",
            },            
            en:{
              label:"Diligence",
              message: "Acting with willingness, doing things right and fulfilling commitments. ",
            },
            fr:{            
              label: "Diligence",            
              message: "Agir avec volonté, bien faire les choses et respecter les engagements."
            }
          },
          {
            icono: "compasion.png",
            es:{
              label: "Humanización",
              message: "Logrando mejor atención y cuidado con nuestros pacientes.",
            },            
            en:{
              label:"Humanization",
              message: "Achieving better attention and care for our patients.",
            },
            fr:{            
              label: "Humanisation",            
              message: "Améliorer l'attention et les soins apportés à nos patients"
            }
          },
          {
            icono: "seguridad.png",
            es:{
              label: "Seguridad",
              message: "Generando confianza, emociones agradables y sentimientos humanos de buen trato a nuestros clientes internos y externos.",
            },            
            en:{
              label:"Security",
              message: "Generating trust, pleasant emotions and human feelings of good treatment to our internal and external customers.",
            },
            fr:{            
              label: "Sécurité",            
              message: "Générer de la confiance, des émotions agréables et des sentiments humains de bon traitement pour nos clients internes et externes"
            }
          },
          {
            icono: "trabajoenequipo.png",
            es:{
              label: "Trabajo",
              message: "Buscando alcanzar juntos las metas. ",
            },            
            en:{
              label:"Teamwork",
              message: "Seeking to achieve our goals together.",
            },
            fr:{            
              label: "Travail d'équipe",            
              message: "Chercher à atteindre nos objectifs ensemble"
            }
          },
        ],
    }
  },
  computed:{
    idioma(){
      return this.$i18n.locale
    }  
  }
};
</script>

<style lang="scss" scoped>
.subcontainer {
  width: 100%;
  padding: 0px 300px;
  background-color: #ffffff;

  .minicontainer {
    padding: 20px 20px;
    align-items: center;
    justify-content: center;
  }

  .image-container {
    text-align: center;
  }
}

.image-cirugia {
  height: 400px;
}

h1 {
  text-align: center;
  padding: 35px 0px;
  background-color: #063165;
  color: white;
  font-size: 50px;
  user-select: none;
  margin: 0px;
}

h2 {
  text-align: center;
  padding: 0px 0px;
  color: #083078;
  font-weight: bold;
  font-size: 40px;
  user-select: none;
  margin-top: 0px;
}

p {
  text-align: justify;
  font-size: 17px;
  user-select: none;
}

.boton-enlace {
  text-align: center;
  background-color: #083078;
  padding: 10px 0px;
  color: white;
  user-select: none;
  width: fit-content;
  height: fit-content;
  border-radius: 3px;
  margin-top: 40px;
  transition: 0.5s all;

  a {
    color: white;
    font-size: 16px;
    width: 100%;
    padding: 10px 20px;
  }
}

.boton-enlace:hover {
  background-color: #2b86d9;
}

h3 {
  font-size: 17px;
  font-weight: bold;
}

h6 {
  margin: 0px;
  padding: 0px;
  font-size: 16px;
  color: #575757;
  font-weight: bold;
  margin-bottom: 15px;
}

.title-main {
  margin-bottom: 50px;
  text-transform: uppercase;
}

.container-iconos-valores {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  padding: 20px;
  margin-top: 50px;
  margin-bottom: 50px;
  min-height: 300px;
}

.container-icon-label {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100px;
  width: 20%;

  span {
    font-size: 14px;
    font-weight: bold;
    color: #083078;
  }
}

@media screen and (max-width: 1470px) {
  .subcontainer {
    padding: 0px 10px;

    .minicontainer {
      padding: 30px 20px;
    }
  }
}

@media screen and (max-width: 470px) {
  .image-cirugia {
    width: 100%;
    height: auto;
  }

  h1 {
    padding: 20px 0px;
    font-size: 35px;
  }
}
</style>
